module.exports = __webpack_public_path__ + "img/delete-icon-black.9fce2d12.svg";